import { render, staticRenderFns } from "./QuickCompanyScope.vue?vue&type=template&id=5529e7da&scoped=true&"
import script from "./QuickCompanyScope.vue?vue&type=script&lang=js&"
export * from "./QuickCompanyScope.vue?vue&type=script&lang=js&"
import style0 from "./QuickCompanyScope.vue?vue&type=style&index=0&id=5529e7da&scoped=true&lang=css&"
import style1 from "./QuickCompanyScope.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5529e7da",
  null
  
)

export default component.exports